export default __webpack_public_path__ + "static/media/icon_alert.c3db8c15.svg";